import React from 'react';
import styles from './Transition.module.css';
import { formatWhen } from './records';

export default function Overview({ summary, onOpenItem, onOpenTracker, onImport, onHistory }) {
    const totals = summary?.totals || {};
    const functions = summary?.by_business_function || [];
    const upcoming = summary?.upcoming || [];
    const attention = summary?.needs_attention || [];
    const asOf = summary?.as_of ? new Date(summary.as_of).toLocaleString() : 'now';

    return (
        <div>
            <div className={styles.overviewIntro}>
                <h2 className={styles.overviewTitle}>Transition Overview</h2>
                <p className={styles.overviewCopy}>A clear view of progress, upcoming work and items needing attention.</p>
            </div>
            <section className={styles.position}>
                <p className={styles.positionKicker}>Overall position</p>
                <p className={styles.positionText}>{summary?.overall_position || 'No authorised tracker items are available for this view.'}</p>
                <p className={styles.positionMeta}>
                    Derived from {totals.tracked_items || 0} authorised records · As of {asOf}
                </p>
            </section>
            <div className={styles.metricRow}>
                <Metric label="Total tracked items" value={totals.tracked_items || 0} onClick={() => onOpenTracker(null)} />
                <Metric label="Completed" value={totals.completed || 0} onClick={() => onOpenTracker('COMPLETE')} />
                <Metric label="In progress" value={totals.in_progress || 0} onClick={() => onOpenTracker('IN_PROGRESS')} />
                <Metric label="Needs attention" value={totals.needs_attention || 0} onClick={() => onOpenTracker('attention')} />
            </div>
            <div className={styles.split}>
                <section className={styles.card}>
                    <div className={styles.cardHead}>Progress by business function</div>
                    {functions.length === 0 ? <p className={styles.finePrint}>No business function has tracked items yet.</p> : null}
                    {functions.map(entry => (
                        <button type="button" className={styles.fnRow} key={entry.business_function} onClick={() => onOpenTracker(null, entry.business_function)}>
                            <div className={styles.fnMain}>
                                <div className={styles.fnName}>{entry.business_function}</div>
                                <div className={styles.bar}>
                                    <span style={{ width: `${entry.progress || 0}%` }} />
                                </div>
                            </div>
                            <span className={styles.fnStat}>{entry.total}</span>
                            <span className={styles.fnStat}>
                                {entry.done} done
                                {entry.unconfirmed ? <span className={styles.fnNote}>{entry.unconfirmed} unconfirmed</span> : null}
                            </span>
                            <span className={styles.fnStat}>{entry.attention} attention</span>
                        </button>
                    ))}
                </section>
                <section className={styles.card}>
                    <div className={styles.cardHead}>What&apos;s coming up</div>
                    {upcoming.length === 0 ? <p className={styles.finePrint}>No confirmed upcoming dates.</p> : null}
                    {upcoming.map(item => (
                        <button type="button" key={item.id} className={styles.upcomingBtn} onClick={() => onOpenItem(item.id)}>
                            <span className={styles.upcomingTitle}>{item.title}</span>
                            <span className={styles.upcomingWhen}>{formatWhen(item.target_date, item.business_function)}</span>
                        </button>
                    ))}
                </section>
            </div>
            <section className={styles.card} style={{ marginTop: 16 }}>
                <div className={styles.cardHead}>Needs attention</div>
                {attention.length === 0 ? <p className={styles.finePrint}>No mapped items currently require attention.</p> : null}
                {attention.length > 0 ? (
                    <table className={styles.attentionTable}>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Reason</th>
                                <th>Owner</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attention.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        <button type="button" className={styles.attentionTitle} onClick={() => onOpenItem(item.id)}>
                                            {item.title}
                                        </button>
                                    </td>
                                    <td className={styles.warn}>{item.reason}</td>
                                    <td className={styles.quiet}>{item.owner}</td>
                                    <td className={styles.accentDate}>{item.target_date || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : null}
                <FooterActions onOpenTracker={onOpenTracker} onImport={onImport} onHistory={onHistory} />
            </section>
        </div>
    );
}

function FooterActions({ onOpenTracker, onImport, onHistory }) {
    return (
        <div className={styles.footerLinks}>
            <button type="button" className={styles.primaryBtn} onClick={() => onOpenTracker(null)}>
                Open Tracker
            </button>
            <button type="button" className={styles.ghostBtn} onClick={onImport}>
                Import / Update
            </button>
            <button type="button" className={styles.ghostBtn} onClick={onHistory}>
                View Import History
            </button>
        </div>
    );
}

function Metric({ label, value, onClick }) {
    return (
        <button type="button" className={styles.metric} onClick={onClick}>
            <span className={styles.metricLabel}>{label}</span>
            <span className={styles.metricValue}>{value}</span>
        </button>
    );
}
